import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import './Loader.Style.scss';
import {TimelineComponent} from "../Timeline/Timeline.Component";

export const LoaderComponent = ({
    isLoading,
    isTimelineSkeleton,
    isSkeleton,
    numberOfItems,
    numberOfRepeat,
    oppositeContentVarient,
    separatorContentVarient,
    skeletonVarient,
    contentVarient,
    oppositeContentItemsVarient,
    contentItemsVarient,
    skeletonItems,
    timelineIdRef,
    idRef,
    wrapperClasses,
    skeletonClasses,
    oppositeContentStyle,
    skeletonStyle,
    contentStyle,
    separatorContentStyle,
}) => isLoading && (
    <div className={`loader-wrapper component-wrapper ${wrapperClasses}`}>
        {isTimelineSkeleton && (
            <TimelineComponent
                data={Array.from({length: numberOfItems}, () => ({}))}
                timelineIdRef={timelineIdRef}
                oppositeContentComponent={
                    (oppositeContentVarient || oppositeContentItemsVarient)
            && (() => (oppositeContentItemsVarient
                && oppositeContentItemsVarient.map((item, index) => (
                    <Skeleton
                        variant={item.varient}
                        key={`${timelineIdRef}Opposite${index + 1}`}
                        style={{
                            width: '100%',
                            minHeight: item.minHeight,
                            ...(item.style || {}),
                        }}
                    />
                ))) || (
                <Skeleton
                    variant={oppositeContentVarient}
                    style={{
                        width: '100%',
                        height:
                      (oppositeContentVarient !== 'text' && '100%') || undefined,
                        ...(oppositeContentStyle || {}),
                    }}
                />
            ))
                }
                separatorContentComponent={() => (
                    <Skeleton
                        variant={separatorContentVarient}
                        style={{
                            width: '100%',
                            height: (separatorContentVarient !== 'text' && '100%') || undefined,
                            ...(separatorContentStyle || {}),
                        }}
                    />
                )}
                contentComponent={
                    (contentItemsVarient || contentVarient)
            && (() => (contentItemsVarient
                && contentItemsVarient.map((item, index) => (
                    <Skeleton
                        variant={item.varient}
                        key={`${timelineIdRef}${index + 1}`}
                        style={{
                            width: '100%',
                            minHeight: item.minHeight,
                            ...(item.style || {}),
                        }}
                    />
                ))) || (
                <Skeleton
                    variant={contentVarient}
                    style={{
                        width: '100%',
                        height: (contentVarient !== 'text' && '100%') || undefined,
                        ...(contentStyle || {}),
                    }}
                />
            ))
                }
            />
        )}
        {(isSkeleton || skeletonItems)
        && ((skeletonItems
          && Array.from({length: numberOfRepeat || 1}, () => skeletonItems).flat()
              .map((item, index) => (
                  <Skeleton
                      key={`${idRef}${index + 1}`}
                      variant={item.varient}
                      className={item.className}
                      style={{
                          width: '100%',
                          ...(item.style || {}),
                      }}
                  />
              ))) || (
            <Skeleton
                variant={skeletonVarient}
                className={skeletonClasses}
                style={{
                    width: '100%',
                    height: (skeletonVarient !== 'text' && '100%') || undefined,
                    ...(skeletonStyle || {}),
                }}
            />
        ))}
    </div>
);

LoaderComponent.propTypes = {
    numberOfItems: PropTypes.number,
    numberOfRepeat: PropTypes.number,
    oppositeContentItemsVarient: PropTypes.arrayOf(
        PropTypes.shape({
            varient: PropTypes.oneOf(['rectangular', 'circular', 'text']),
            minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            style: PropTypes.instanceOf(Object),
        }),
    ),
    contentItemsVarient: PropTypes.arrayOf(
        PropTypes.shape({
            varient: PropTypes.oneOf(['rectangular', 'circular', 'text']),
            minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            style: PropTypes.instanceOf(Object),
        }),
    ),
    skeletonItems: PropTypes.arrayOf(
        PropTypes.shape({
            varient: PropTypes.oneOf(['rectangular', 'circular', 'text']),
            minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            className: PropTypes.string,
            style: PropTypes.instanceOf(Object),
        }),
    ),
    isLoading: PropTypes.bool,
    isSkeleton: PropTypes.bool,
    isTimelineSkeleton: PropTypes.bool,
    timelineIdRef: PropTypes.string,
    wrapperClasses: PropTypes.string,
    idRef: PropTypes.string,
    skeletonClasses: PropTypes.string,
    oppositeContentStyle: PropTypes.instanceOf(Object),
    skeletonStyle: PropTypes.instanceOf(Object),
    contentStyle: PropTypes.instanceOf(Object),
    separatorContentStyle: PropTypes.instanceOf(Object),
    skeletonVarient: PropTypes.oneOf(['rectangular', 'circular', 'text']),
    oppositeContentVarient: PropTypes.oneOf(['rectangular', 'circular', 'text']),
    separatorContentVarient: PropTypes.oneOf(['rectangular', 'circular', 'text']),
    contentVarient: PropTypes.oneOf(['rectangular', 'circular', 'text']),
};
LoaderComponent.defaultProps = {
    numberOfItems: 3,
    numberOfRepeat: 1,
    isLoading: false,
    isTimelineSkeleton: false,
    isSkeleton: false,
    skeletonVarient: 'rectangular',
    skeletonItems: undefined,
    oppositeContentItemsVarient: undefined,
    oppositeContentStyle: undefined,
    skeletonStyle: undefined,
    contentStyle: undefined,
    separatorContentStyle: undefined,
    contentItemsVarient: undefined,
    timelineIdRef: 'loaderTimelineRef',
    idRef: 'loaderRef',
    oppositeContentVarient: undefined,
    wrapperClasses: '',
    skeletonClasses: '',
    separatorContentVarient: 'circular',
    contentVarient: undefined,
};
